import { render } from "./ClientRole.vue?vue&type=template&id=76a3b7b2"
import script from "./ClientRole.vue?vue&type=script&lang=js"
export * from "./ClientRole.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__